export enum WorkStatusEnum {
  InHouse = 'In-house',
  Outsource = 'Outsource',
}

export const WorkStatusArray = [
  WorkStatusEnum.InHouse,
  WorkStatusEnum.Outsource,
];
